import React from 'react';

import context from './context';
import { IContextProps } from './types';

const useContext = (): IContextProps => {
  return React.useContext(context);
};

export default useContext;